export class RequestCreditCard {
  patientId: number;
  appointmentId: number;
}
